import type { ChipMeta } from '../../utils/dossierFlavor';

interface DossierFlavorChipProps {
  meta: ChipMeta;
}

/**
 * SF-156 Component 6: shared presentational pill for the Race/Rank/Personality flavor chips —
 * consumes `dossierFlavor.ts`'s pure `{icon, color, label}` metadata. Split out of that module
 * because a `.ts` file can't export JSX under this project's TypeScript config.
 */
export function DossierFlavorChip({ meta }: DossierFlavorChipProps) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 11,
        fontWeight: 700,
        padding: '2px 8px',
        borderRadius: 10,
        border: `1px solid ${meta.color}`,
        color: meta.color,
      }}
    >
      <span aria-hidden="true">{meta.icon}</span>
      <span>{meta.label}</span>
    </span>
  );
}
